// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wGXA","colBig":"styles_colBig__1HG1k","colSmall":"styles_colSmall__1_4cv","shopifyNameWrapper":"styles_shopifyNameWrapper__170IR"};